<template>
  <div class="traffic-level">
    <div class="traffic-level__title d-flex align-items-center gap-2 mb-2">
      <p class="mb-0">{{ $t('routeOptimization.fields.traffic') }}</p>
      <McInfoTooltip id="traffic_level" :tooltip="$t('routeOptimization.tooltip.traffic')" />
    </div>

    <div class="row">
      <div class="traffic-level__section col-12 col-md-3">
        <FormulateInput
          id="trafficLevel"
          name="ignore_traffic_level"
          v-model="formValues.traffic_level"
          class="p-0 __form-traffic"
          type="select-resourceful-v2"
          trackBy="key"
          ignored
          :placeholder="'Pilih Lalu Lintas'"
          :optionsGetter="resourcefulQuery.trafficLevels"
          :optionLabelFn="({ item }) => item.label"
          :fullObject="fullObject.trafficLevel"
          @update:fullObject="($event) => (fullObject.trafficLevel = $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import getTrafficLevels from '../../../lib/constants/traffic-levels'
import McInfoTooltip from '@/components/McInfoTooltip'

export default {
  components: {
    McInfoTooltip,
  },
  props: {
    trafficLevel: {
      type: String,
      default: 'slow',
    },
  },
  emits: ['update:trafficLevel'],
  data() {
    return {
      formValues: {
        traffic_level: this.trafficLevel,
      },
      fullObject: {
        trafficLevel: {},
      },
    }
  },
  computed: {
    trafficLevels() {
      return getTrafficLevels(this)
    },
    resourcefulQuery() {
      return {
        trafficLevels: (opts) => {
          let result = {}
          let trafficLevels = this.trafficLevels
          if (opts.search)
            trafficLevels = trafficLevels.filter((item) => this.isContains(opts.search, item.label))

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: trafficLevels,
            },
          }

          return result
        },
      }
    },
  },
  watch: {
    'formValues.traffic_level': {
      async handler(newValue) {
        if (!newValue) {
          await this.$nextTick()
          this.formValues.traffic_level = 'slow'
          this.updateTrafficLevelObject('slow')
          this.$emit('update:trafficLevel', 'slow')
          return
        }
        this.handleTrafficLevelChange(newValue)
      },
      immediate: true,
    },
    trafficLevel: {
      handler(newValue) {
        if (newValue) {
          this.formValues.traffic_level = newValue
          this.updateTrafficLevelObject(newValue)
        }
      },
      immediate: true,
    },
  },
  methods: {
    isContains(search, text) {
      return text.toLowerCase().includes(search.toLowerCase())
    },

    handleTrafficLevelChange(newValue) {
      this.updateTrafficLevelObject(newValue)
      this.$emit('update:trafficLevel', newValue)
    },

    updateTrafficLevelObject(trafficLevelKey) {
      const selectedTraffic = this.trafficLevels.find((item) => item.key === trafficLevelKey)
      if (selectedTraffic) {
        this.fullObject.trafficLevel = selectedTraffic
      }
    },

    resetFormValues() {
      this.formValues = {
        traffic_level: this.trafficLevel || 'slow',
      }
      this.updateTrafficLevelObject(this.trafficLevel || 'slow')
    },
  },
}
</script>
